"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BindEquip',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default,
    selPlat: _selPlat.default
  },
  props: {
    user_type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      nowTime: Date.parse(new Date()) / 1000,
      deviceState: ['掉线', '正常', '维护', '异常'],
      form: {},
      numInfo: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        search_agent_id: '0',
        son_id: this.$route.query.son_id || '',
        device_status: this.$route.query.device_status || 0,
        search_goods_type: '-1',
        search_user_type: '0',
        page_num: 1,
        limit: 20
      },
      type_device_num: [],
      tabDevice: [],
      allDevice: {},
      total_device_num: 0,
      all: this.$route.query.all || 0,
      agent_id: this.$route.query.agent_id || '',
      ad_id: this.$route.query.ad_id || '',
      selSnArr: [],
      selID: [],
      device_row: {},
      // 设备归属
      eqiupBelong: [],
      eqiupStore: {},
      equipBelongDialog: false,
      // 设备弹出
      statusArr: ['在槽', '借出中', '已借出', '异常'],
      baoList: [],
      baoDialog: false,
      upgradeDialog: false,
      upgradeObj: {},
      systemUpgrade: {},
      onlineLogDialog: false,
      onlineLogList: [],
      currentDeviceId: '',
      onlineLogQuery: {
        start: 1,
        limit: 10,
        page_num: 1
      },
      sort_id_key: this.$route.query.sort_id_key || false,
      search_factorys_condition: {},
      search_device_condition: {},
      search_device_inet_condition: []
    };
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    },
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    showElectricityColumn: function showElectricityColumn() {
      var deviceType = this.listQuery.search_goods_type;
      if (deviceType == -1 || deviceType === '-1') return true;
      if (deviceType == 3 || deviceType === '3') return true;
      var key = String(deviceType);
      return this.deviceKeyObj && this.deviceKeyObj[key] === '充电桩';
    }
  },
  mounted: function mounted() {
    this.listQuery.search_user_type = this.user_type;
    this.getStatNum();
    this.getList();
    this.getSystemUpgrade();
    this.getDeviceList();
  },
  methods: {
    /**
     * 信号值注解
     */
    renderHeader: function renderHeader(h, _ref) {
      var column = _ref.column,
        $index = _ref.$index;
      return [column.label, h('el-tooltip', {
        props: {
          content: '0~31，31为最好，大于18方可连接网络',
          placement: 'top'
        }
      }, [h('span', {
        class: {
          'el-icon-question': true
        }
      })])];
    },
    /**
     * 获取设备类型
     */
    getDeviceList: function getDeviceList() {
      var _this = this;
      this.$get('agentapi/goods/goods_detail_types', {
        limit: 1000
      }).then(function (res) {
        var tabDevice = {},
          tabDeviceID = {},
          arr = [],
          allDevice = {};
        res.list.map(function (item) {
          //如果tyep_name不在this.deviceNameObj中则不返回
          if (!_this.deviceNameObj.hasOwnProperty(item.type_name)) {
            return;
          }
          if (!tabDevice["t_".concat(item.goods_type)]) {
            tabDeviceID[item.id] = item.depend_type;
            allDevice[item.depend_type] = [];
            allDevice[item.depend_type].push(item);
            tabDevice["t_".concat(item.goods_type)] = item;
          } else {
            arr.push(item);
          }
        });
        for (var i in tabDeviceID) {
          arr.map(function (item) {
            if (item.depend_type == tabDeviceID[i]) {
              allDevice[tabDeviceID[i]].push(item);
            }
          });
        }
        _this.tabDevice = tabDevice;
        _this.allDevice = allDevice;
      });
    },
    /**
     * 系统维护状态
     */
    getSystemUpgrade: function getSystemUpgrade() {
      var _this2 = this;
      this.$get('agentapi/system/upgrade_switch').then(function (res) {
        _this2.systemUpgrade = res;
      });
    },
    /**
     * 数量
     */
    getStatNum: function getStatNum() {
      var _this3 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form);
      this.$get('agentapi/device_data_stat_num', listQuery).then(function (res) {
        _this3.numInfo = res;
        _this3.tableMaxH = window.innerHeight - _this3.$refs.equip_table.$el.offsetTop - 80;
      });
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.device_status = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 校验是否可选
     */
    checkSel: function checkSel(row) {
      if (this.ad_id) {
        return true;
      } else {
        return row.is_distributed == 0;
      }
    },
    /**
     * 选择设备
     * @param {Object} res
     */
    selSb: function selSb(list) {
      var selSnArr = [],
        selID = [];
      for (var i in list) {
        selSnArr.push(list[i].goods_sn);
        selID.push(list[i].id);
      }
      this.selSnArr = selSnArr;
      this.selID = selID;
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getStatNum();
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this4 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      if (this.sort_id_key && window.sort_id_key) listQuery.sort_id_key = window.sort_id_key;
      this.$get('agentapi/search/query_devices2', listQuery).then(function (res) {
        // SySearch/getGoodsList
        _this4.listLoading = false;
        _this4.list = res.list;
        _this4.listQuery.page_num = res.page_num;
        if (_this4.total_device_num == 0) {
          for (var i in res.type_device_num) {
            _this4.total_device_num += res.type_device_num[i];
          }
          _this4.type_device_num = res.type_device_num;
        }
        _this4.tableMaxH = window.innerHeight - _this4.$refs.equip_table.$el.offsetTop - 115;
        if (_this4.search_device_inet_condition.length == 0) {
          _this4.search_factorys_condition = res.search_factorys_condition;
          _this4.search_device_condition = res.search_device_condition;
          _this4.search_device_inet_condition = res.search_device_inet_condition;
        }
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    /**
     * @param {Object} row
     * 解绑设备
     */
    deleteEquip: function deleteEquip(row) {
      var _this5 = this;
      var that = this;
      this.$alert('确定解绑此商户的设备吗？', '解绑设备', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            // 【操作埋点】2026-05-25 pc_equipment_unbind_1 解绑设备
            _this5.$post('agentapi/unset_binded_zuo', {
              zuo_sn: row.goods_sn
            }, {
              operation_option: '解绑设备',
              content: "\u89E3\u7ED1\u8BBE\u5907\u3010".concat(row.goods_name || row.goods_sn, "\u3011\uFF0CSN\uFF1A").concat(row.goods_sn, "\uFF0C\u539F\u5546\u6237\uFF1A").concat(row.store_name || '无'),
              operation_id: 'pc_equipment_unbind_1'
            }).then(function (res) {
              _this5.$message({
                message: '解绑成功',
                type: 'success'
              });
              row.is_distributed = 0;
              row.store_id = '';
              row.store_name = '';
            });
          }
        }
      });
    },
    /**
     * type 1 铺货 2 去分配 3 直接分配 4 回收设备 5 设置房间号
     */
    distribu: function distribu() {
      var _this6 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var row = arguments.length > 1 ? arguments[1] : undefined;
      var selSn = this.selSnArr.join(',');
      switch (type) {
        case 1:
          this.$router.push({
            path: '/shop/allShop',
            query: {
              zuo_sn: row ? row.goods_sn : selSn
            }
          });
          break;
        case 2:
          this.$router.push({
            path: '/agent/index',
            query: {
              zuo_sn: row ? row.goods_sn : selSn
            }
          });
          break;
        case 3:
          this.loadObj = this.$loading({
            lock: true,
            text: '正在分配',
            spinner: 'el-icon-loading'
          });

          // 【操作埋点】2026-05-25 pc_equipment_distribute_1 设备铺货/分配
          this.$post('agentapi/save_distribute_agent_devices', {
            son_id: this.agent_id,
            goods_sn: row ? [row.goods_sn] : this.selSnArr
          }, {
            operation_option: '设备铺货',
            content: "\u5206\u914D ".concat(row ? 1 : this.selSnArr.length, " \u53F0\u8BBE\u5907\u5230\u4EE3\u7406(ID:").concat(this.agent_id, ")\uFF0CSN\uFF1A").concat(row ? row.goods_sn : this.selSnArr.join(',')),
            operation_id: 'pc_equipment_distribute_1'
          }).then(function (res) {
            _this6.loadObj.close();
            _this6.$message({
              message: '分配成功',
              type: 'success'
            });
            history.back();
          });
          break;
        case 4:
          this.loadObj = this.$loading({
            lock: true,
            text: '正在回收',
            spinner: 'el-icon-loading'
          });

          // 【操作埋点】2026-05-25 pc_equipment_recover_1 回收设备
          this.$post('agentapi/save_recover_agent_devices', {
            son_id: this.listQuery.son_id || row.manage_aid,
            goods_sn: row ? [row.goods_sn] : this.selSnArr
          }, {
            operation_option: '回收设备',
            content: "\u4ECE\u4EE3\u7406(ID:".concat(this.listQuery.son_id || row.manage_aid, ")\u56DE\u6536 ").concat(row ? 1 : this.selSnArr.length, " \u53F0\u8BBE\u5907\uFF0CSN\uFF1A").concat(row ? row.goods_sn : this.selSnArr.join(',')),
            operation_id: 'pc_equipment_recover_1'
          }).then(function (res) {
            _this6.loadObj.close();
            _this6.$message({
              message: '回收成功',
              type: 'success'
            });
            if (!row.manage_aid) {
              history.back();
            } else {
              _this6.getList();
            }
          });
          break;
        case 5:
          this.$prompt('请输入房间号', '房间号', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: row.attach_room_no || ''
          }).then(function (_ref2) {
            var value = _ref2.value;
            // 【操作埋点】2026-05-25 pc_equipment_room_no_1 设置房间号
            _this6.$post('agentapi/device/save_device_room_no', {
              goods_sn: row.goods_sn,
              attach_room_no: value
            }, {
              operation_option: '设置房间号',
              content: "\u8BBE\u5907 SN:".concat(row.goods_sn, " \u8BBE\u7F6E\u623F\u95F4\u53F7\u300C").concat(value, "\u300D\uFF0C\u5546\u6237\uFF1A").concat(row.store_name || '无'),
              operation_id: 'pc_equipment_room_no_1'
            }).then(function (res) {
              _this6.$message({
                message: '设置成功',
                type: 'success'
              });
              row.attach_room_no = value;
            });
          });
          break;
      }
    },
    /**
     * @param {Object} row
     * 绑定广告
     */
    bindAd: function bindAd(row) {
      var _this7 = this;
      var selSnArr = this.selSnArr;
      if (row) selSnArr.push(row.goods_sn);

      // 【操作埋点】2026-05-25 pc_ad_bind_1 设备页绑定广告
      this.$post('agentapi/ad/bind_ad_sns', {
        id: this.ad_id,
        goods_sn: selSnArr
      }, {
        operation_option: '绑定广告',
        content: "\u5E7F\u544AID ".concat(this.ad_id, " \u7ED1\u5B9A\u5230 ").concat(selSnArr.length, " \u53F0\u8BBE\u5907\uFF0CSN\uFF1A").concat(selSnArr.join(',')),
        operation_id: 'pc_ad_bind_1'
      }).then(function (res) {
        _this7.$message({
          message: '绑定成功',
          type: 'success'
        });
        history.back();
      });
    },
    /**
     * 设备信息
     */
    equipBelong: function equipBelong(row) {
      var _this8 = this;
      this.$get('agentapi/get_device_manager', {
        goods_sn: row.goods_sn
      }).then(function (res) {
        _this8.eqiupBelong = res.belong;
        _this8.eqiupStore = res.bind_store || {};
        _this8.equipBelongDialog = true;
      });
    },
    /**
     * 展示设备升级层
     * @param {Object} row
     */
    showUpgrade: function showUpgrade(row) {
      this.upgradeObj = {
        upgrade_status: parseInt(row.upgrade_status),
        upgrade_desc: row.upgrade_desc,
        updating_depend: row.updating_depend || [],
        goods_sn: row.goods_sn || ''
      };
      this.device_row = row;
      this.upgradeDialog = true;
    },
    /**
     * 设备升级
     */
    setUpgrade: function setUpgrade() {
      var _this9 = this;
      var url = 'agentapi/system/upgrade_switch',
        params;
      params = this.upgradeObj;
      if (params.goods_sn) {
        params.zuo_sn = this.upgradeObj.goods_sn;
        url = 'agentapi/device/upgrade_switch';
      }
      var upgradeContent = "\u8BBE\u5907 SN:".concat(params.goods_sn || params.zuo_sn || '', "\uFF0C\u5347\u7EA7\u72B6\u6001\uFF1A").concat(params.upgrade_status === 2 ? '开启' : '关闭', "\uFF0C\u8BF4\u660E\uFF1A").concat(params.upgrade_desc || '无');

      // 【操作埋点】2026-05-25 pc_equipment_upgrade_1 设备升级开关
      this.$post(url, params, {
        operation_option: '设备升级',
        content: upgradeContent,
        operation_id: 'pc_equipment_upgrade_1'
      }).then(function (res) {
        _this9.$message({
          message: '设置成功',
          type: 'success'
        });
        _this9.device_row.upgrade_status = params.upgrade_status;
        _this9.upgradeDialog = false;
      });
    },
    /**
     * 生成二维码图片
     */
    createImg: function createImg(row) {
      var that = this;
      that.downLoad = this.$loading({
        lock: true,
        text: '下载中，请耐心等待',
        spinner: 'el-icon-loading'
      });
      that.$getZip('QRcode/createSocketCodeSnImage', {
        code_sn: row.goods_sn
      }).then(function (res) {
        var blob = new Blob([res], {
          type: 'application/octet-stream'
        });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a'); // 创建a标签
        link.href = url;
        link.download = row.goods_sn + '_links.txt'; // 重命名文件
        link.click();
        that.downLoad.close();
        URL.revokeObjectURL(url); // 释放内存
      });
    },
    /**
     * 设备二维码
     */
    showCode: function showCode(row) {
      var _this0 = this;
      if (row.code_sn_src) {
        this.$alert('<div class="text-center"><img src="' + row.code_sn_src + '" width="250"/></div>', '设备二维码', {
          dangerouslyUseHTMLString: true
        });
      } else if (row.code_sn_body) {
        this.$get('QRcode/createCodeSnImage', {
          code_sn: row.goods_sn
        }).then(function (res) {
          row.code_sn_src = res.img_url;
          _this0.$alert('<div class="text-center"><img src="' + row.code_sn_src + '" width="250"/></div>', '设备二维码', {
            dangerouslyUseHTMLString: true
          });
        });
      }
    },
    /**
     * @param {Object} row
     * 重启设备
     */
    restart: function restart(row) {
      var _this1 = this;
      var that = this;
      this.$alert('确定重启此设备吗？', '重启设备', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            // 【操作埋点】2026-05-25 pc_equipment_restart_1 重启设备
            _this1.$post('agentapi/device/reboot', {
              goods_sn: row.goods_sn
            }, {
              operation_option: '重启设备',
              content: "\u91CD\u542F\u8BBE\u5907\u3010".concat(row.goods_name || row.goods_sn, "\u3011\uFF0CSN\uFF1A").concat(row.goods_sn),
              operation_id: 'pc_equipment_restart_1'
            }).then(function (res) {
              _this1.getList();
              _this1.$message({
                message: '操作成功',
                type: 'success'
              });
            });
          }
        }
      });
    },
    /**
     * @param {Object} row
     * 重启pile设备
     */
    restartPile: function restartPile(row) {
      var _this10 = this;
      var deviceId = row.device_id;
      if (!deviceId) {
        this.$message({
          message: '设备ID不存在',
          type: 'error'
        });
        return;
      }
      this.$alert('确定远程重启此设备吗？', '远程重启', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this10.$get('agentapi/device/reboot_pile', {
              device_id: deviceId
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_equipment_restart_1 远程重启（$get 需手动调用 $equipmentReport）
              _this10.$equipmentReport.reportEquipmentRestart({
                goods_name: row.goods_name,
                goods_sn: row.goods_sn
              }, 'remote_restart');
              _this10.getList();
              _this10.$message({
                message: '重启指令已发送',
                type: 'success'
              });
            }).catch(function (error) {
              _this10.$message({
                message: '重启失败: ' + error.message,
                type: 'error'
              });
            });
          }
        }
      });
    },
    /**
     * 显示掉线/上线日志
     * @param {Object} row
     */
    showOnlineLog: function showOnlineLog(row) {
      this.currentDeviceId = row.device_id || row.goods_sn;
      this.onlineLogQuery.start = 1;
      this.onlineLogDialog = true;
      this.onlineLogList = [];
      this.getOnlineLogList();
    },
    /**
     * 获取掉线/上线日志列表
     */
    getOnlineLogList: function getOnlineLogList() {
      var _this11 = this;
      this.$get('agentapi/device/online_log', {
        device_id: this.currentDeviceId,
        start: this.onlineLogQuery.start - 1,
        limit: this.onlineLogQuery.limit
      }).then(function (res) {
        _this11.onlineLogList = res.list || [];
        _this11.onlineLogQuery.page_num = res.page_num || 1;
      });
    },
    /**
     * 设置设备成本价
     * @param {Object} row
     */
    costPrice: function costPrice() {
      var _this12 = this;
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$prompt('请输入设备成本', '设备成本', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.cost_price || ''
      }).then(function (_ref3) {
        var value = _ref3.value;
        // 【操作埋点】2026-05-25 pc_equipment_cost_1 设置设备成本
        _this12.$post('agentapi/device/goods_attr', {
          goods_id: row.id ? [row.id] : _this12.selID,
          cost_price: value
        }, {
          operation_option: '设置设备成本',
          content: row.id ? "\u8BBE\u7F6E\u8BBE\u5907 SN:".concat(row.goods_sn, " \u6210\u672C\u4EF7\u4E3A ").concat(value, " \u5143") : "\u6279\u91CF\u8BBE\u7F6E ".concat(_this12.selID.length, " \u53F0\u8BBE\u5907\u6210\u672C\u4EF7\u4E3A ").concat(value, " \u5143"),
          operation_id: 'pc_equipment_cost_1'
        }).then(function (res) {
          _this12.$message({
            message: '设置成功',
            type: 'success'
          });
          if (row.cost_price) {
            row.cost_price = value;
          } else {
            _this12.getList();
          }
        });
      });
    }
  }
};